export default __webpack_public_path__ + "static/media/default.ded7a662de97659841336bcb3176c88c.png";